

















import { Component, Vue } from "vue-property-decorator";
import VThree from "@/components/VThree.vue";
import { Color, PerspectiveCamera, Renderer, Scene } from "three";
import { METER } from "@/utils/Constants";

@Component({
  components: {
    VThree,
  },
})
export default class CustomComponents extends Vue {
  readonly camera: PerspectiveCamera = new PerspectiveCamera(
    45,
    innerWidth / innerHeight,
    0.1,
    100 * METER
  );
  readonly scene = new Scene();

  onReady(_renderer: Renderer) {
    this.camera.position.z = 5;
    this.scene.background = new Color(0xff0000);
    // const geometry = new SphereGeometry(50 * METER, 2 * METER, 2 * METER);
    // const material = new MeshBasicMaterial({ color: new Color(0x00ff00) });
    // const sphere = new Mesh(geometry, material);
    // // sphere.position.set(100, 100, 100);

    // this.scene.add(sphere);
  }

  onRender(_renderer: Renderer) {}
}
